import React from 'react'
import PropTypes from 'prop-types'
import { Confirm } from 'semantic-ui-react'

export const EditorUnsavedModalView = (props) => {
  const { showModal, handleConfirm, handleCancel } = props

  return (
    <Confirm
      confirmButton='Continue and Lose Changes'
      content='There are unsaved changes, are you sure you would like to continue?'
      header='Unsaved Changes'
      onCancel={handleCancel}
      onConfirm={handleConfirm}
      open={showModal}
      data-testid='editor-unsaved-modal'
    />
  )
}

EditorUnsavedModalView.displayName = 'EditorUnsavedModalView'

EditorUnsavedModalView.propTypes = {
  showModal: PropTypes.bool.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
}
